import { Maybe } from 'graphql/jsutils/Maybe'
import React, { FunctionComponent, memo, useCallback } from 'react'
import { Link } from 'react-router-dom'

import { Label as LabelType } from '../../../graphql/generated'
import { ColorPalleteKey } from '../../utils/collorPallete'
import { IconPalleteKey } from '../../utils/iconPallete'
import { LabelKey } from '../../utils/labelsTypes'
import { labelDetailPath, tabPath } from '../../utils/paths'
import { Label } from '../Label/Label'

interface InlineLabelsGroupProps {
  labels: Maybe<Partial<LabelType>>[] | null | undefined
  labelEntityType?: LabelKey
}

export const InlineLabelsGroup: FunctionComponent<InlineLabelsGroupProps> =
  memo(props => {
    const linkTo = useCallback(
      (id?: string) => tabPath(labelDetailPath(id), props.labelEntityType),
      [props.labelEntityType]
    )

    if (!props.labels || props.labels.length === 0) return null

    return (
      <div className="flex flex-wrap content-center flex-1 gap-2">
        {props.labels.map(label => (
          <Link
            to={linkTo(label?.id)}
            key={label?.id}
            title="Klknutím přejdete na detail štítku"
          >
            <Label
              colorKey={label?.colorKey as ColorPalleteKey}
              iconKey={label?.iconKey as IconPalleteKey}
              name={label?.name || ''}
              description={label?.description || ''}
            />
          </Link>
        ))}
      </div>
    )
  })
